import { ComponentProps, ReactNode } from 'react';
import clsx from 'clsx';

import styles from './Person.module.css';

interface PersonProps extends Omit<ComponentProps<'div'>, 'title'> {
  image?: ReactNode;
  title: ReactNode;
  subtitle?: ReactNode;
  cta?: ReactNode;
  size?: 'md' | 'sm';
}

export default function Person({ title, subtitle, image, cta, className, size = 'md', ...props }: PersonProps) {
  return (
    <div
      className={clsx(styles.person, className, styles[size])}
      itemScope
      itemType="https://schema.org/Person"
      {...props}
    >
      <div
        className={styles.avatar}
        itemProp="image"
      >
        {image}
      </div>

      <div className={styles.content}>
        <p
          className={styles.name}
          itemProp="name"
        >
          {title}
        </p>
        <p className={styles.role}>{subtitle}</p>
      </div>

      {cta && (
        <div
          className={styles.cta}
          itemProp="url"
        >
          {cta}
        </div>
      )}
    </div>
  );
}
